// SustainableGames.js - Component for displaying sustainable games that users can unlock through donations
import React from 'react';

function SustainableGames() {
    // Add modal styles inline to avoid needing the imported CSS
    const modalStyles = {
        modal: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
        },
        modalContent: {
            width: '90%',
            maxWidth: '800px',
            height: '90%',
            maxHeight: '800px',
            backgroundColor: '#1f2937',
            borderRadius: '8px',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid #374151'
        },
        modalHeader: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '1rem',
            backgroundColor: '#111827',
            borderBottom: '1px solid #374151'
        },
        modalTitle: {
            fontSize: '1.25rem',
            fontWeight: 'bold',
            color: '#fff'
        },
        closeButton: {
            background: 'transparent',
            border: 'none',
            color: '#9ca3af',
            fontSize: '1.5rem',
            cursor: 'pointer',
            padding: '0.25rem 0.5rem',
            lineHeight: 1
        },
        iframe: {
            flex: 1,
            width: '100%',
            height: '100%',
            border: 'none',
            backgroundColor: '#111827'
        },
        gameCard: {
            position: 'relative',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            transform: 'translateY(0)',
            transition: 'transform 0.3s ease'
        }
    };

    return (
        <section className="py-16 bg-gray-900 relative overflow-hidden">
            {/* Add top border gradient directly */}
            <div 
                className="absolute top-0 left-0 right-0 h-2.5" 
                style={{
                    background: 'linear-gradient(90deg, #22c55e, #059669, #0ea5e9)',
                    opacity: 0.7,
                    zIndex: 2
                }}
            ></div>

            <div className="container mx-auto px-4">
                <div className="text-center mb-12">
                    <h2 className="text-4xl font-bold mb-4">
                        <span className="text-white">Sustainable </span>
                        <span className="text-green-400">Games</span>
                    </h2>
                    <p className="text-xl text-gray-300 mb-8">
                        Learn about sustainable computing while having fun!
                    </p>
                </div>

                <div className="max-w-4xl mx-auto">
                    <div 
                        className="bg-gray-800 rounded-xl overflow-hidden shadow-xl border border-gray-700"
                        style={modalStyles.gameCard}
                        onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                        onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                    >
                        <div className="p-6 text-center">
                            <h3 className="text-2xl font-bold text-white mb-4">
                                Sustainable Computer Collector
                            </h3>
                            <p className="text-gray-300 mb-6">
                                Guide your eco-friendly snake to collect old computers and build a sustainable computing network. Avoid obstacles and don't crash!
                            </p>
                            <button 
                                onClick={() => window.location.href = '/sustainable-snake-game.html'}
                                className="bg-green-500 hover:bg-green-600 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105"
                            >
                                Play Now
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default SustainableGames;
